import script from "./DashboardStatsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardStatsChart.vue?vue&type=script&setup=true&lang=js"

import "./DashboardStatsChart.vue?vue&type=style&index=0&id=7a8a05c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8a05c0"]])

export default __exports__